import React from 'react';

class QR extends React.Component {
	render() {
		return (
			<div>
				<div style={{ textAlign: 'center', marginTop: '20px' }}>
					En andel kostar: <span style={{ fontWeight: 'bold' }}>{ parseInt(this.props.settings.share_price, 10) } kr</span>
				</div>

				<h1 style={{ marginTop: '5px', marginBottom: '20px' }}>QR-kod för { this.props.shares } andelar</h1>

				<div style={{ float: 'left', width: '100%', textAlign: 'center' }}>
					QR KOD KOMMER HÄR
				</div>

				<div style={{ float: 'left', width: '100%', marginTop: '20px', textAlign: 'center' }}>
					<div onClick={ () => this.props.parent.setState({ page: 'home' }) } className="button pink2-invert auto-width">Tillbaka</div>
				</div>
			</div>
		)
	}
}
export default QR;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/QR.js